import { renderToString } from "react-dom/server";
import { parseDateString } from "../../util/date";
import { KlientkontoerklaeringMetadata } from "../../interfaces/klientkontoerklaering";

export default function HtmlResultSimple(props: {
  metadata: KlientkontoerklaeringMetadata;
}) {
  // HVIS DER ÆNDRES I INDHOLDET af formTitle SKAL DER MULIGVIS ÆNDRES BACKEND DA formTitle BEHANDLES I BACKEND FOR IS-ERKLÆRINGER!
  // formTitle findes 3 steder i dette projekt!!!
  const formTitle = `Erklæring vedr. klienttilsvar m.v. pr. ${parseDateString(
    props.metadata.slutDato,
  )} for 
    ${props.metadata.person ? props.metadata.person.navn : ""}${
      props.metadata.firma
        ? props.metadata.firma.navn + ", CVR-nr. " + props.metadata.firma.cvr
        : ""
    }`;
  const advEllerSelskab = `${
    props.metadata.person ? "Jeg" : "Advokatselskabet"
  }`;
  return (
    <div className="as-document">
      <h1>{formTitle}</h1>
      <p>
        <small>
          Tidspunkt: {new Date().toLocaleDateString("DA-dk")} kl.{" "}
          {new Date().toLocaleTimeString("DA-dk", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </small>
      </p>
      <section>
        <h2>
          {advEllerSelskab} har ikke været i besiddelse af betroede midler i det
          forløbne år. (Sæt kryds)
        </h2>
      </section>
    </div>
  );
}

export function getHtmlResultSimple(metadata: KlientkontoerklaeringMetadata) {
  return renderToString(<HtmlResultSimple metadata={metadata} />).replaceAll(
    "<!-- -->",
    "",
  );
}
